"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DailySignInviteinit = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var bindClient_1 = require("../../model/bindClient");
var service_1 = require("../../../library/base/service");
var DailySignInviteinit = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(DailySignInviteinit, _super);
    function DailySignInviteinit() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '每日签到邀请初始化';
        _this.code = '300428';
        _this.desc = '每日签到邀请初始化';
        _this.requestParams = new bindClient_1.InitRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return DailySignInviteinit;
}(service_1.BaseService));
exports.DailySignInviteinit = DailySignInviteinit;
//# sourceMappingURL=dailySignInviteinit.js.map